import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=225cc9f3&scoped=true&"
import script from "./MainComponent.vue?vue&type=script&lang=js&"
export * from "./MainComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cc9f3",
  null
  
)

export default component.exports